import { Button } from '@mui/material';
import { AlertDialog } from 'src/components';
import { AlertDialogTagTypeChangeContent } from '../AlertDialogContent';
import {
  ALERT_DIALOG_CANCEL_BUTTON_LABEL,
  ALERT_DIALOG_CONFIRM_BUTTON_LABEL,
  ALERT_DIALOG_TAG_TYPE_CHANGE_TITLE,
} from '../../config';
import { AlertDialogChangeTagTypeState } from '../../types';
import { GatewayInput } from 'src/types/gateways';

type AlertDialogDeactivateProps = {
  changeTagTypeAlertToggleState: boolean;
  onChangeTagTypeAlertToggle: () => void;
  changeTagTypeAlertState: AlertDialogChangeTagTypeState;
  handleChangeTagType: (name: string, value: string, input: GatewayInput | null) => void;
};

export const AlertDialogTagTypeChange = ({
  changeTagTypeAlertToggleState,
  onChangeTagTypeAlertToggle,
  changeTagTypeAlertState,
  handleChangeTagType,
}: AlertDialogDeactivateProps) => (
  <>
    <AlertDialog
      maxWidth="md"
      testId="change-tag-type-modal"
      open={changeTagTypeAlertToggleState}
      onClose={onChangeTagTypeAlertToggle}
      title={ALERT_DIALOG_TAG_TYPE_CHANGE_TITLE}
      customContent={<AlertDialogTagTypeChangeContent />}
      action={
        <>
          <Button
            variant="outlined"
            color="primary"
            onClick={onChangeTagTypeAlertToggle}
            data-sm="cancel-button"
          >
            {ALERT_DIALOG_CANCEL_BUTTON_LABEL}
          </Button>
          <Button
            variant="contained"
            color="primary"
            data-sm="change-tag-type-button"
            onClick={() =>
              handleChangeTagType(
                changeTagTypeAlertState.name,
                changeTagTypeAlertState.value,
                changeTagTypeAlertState.input
              )
            }
          >
            {ALERT_DIALOG_CONFIRM_BUTTON_LABEL}
          </Button>
        </>
      }
    />
  </>
);
